import is from '@sindresorhus/is';

import type { CommentTarget } from '../types';
import {
    anchorRootSelector,
    commentMarkSelector,
    skillAnchorSelector,
    titleAnchorSelector,
    workflowStepAnchorSelector,
    workflowStepPartAnchorSelector,
} from './grammar';

export const resolveAnchorRoot = (itemId: string): HTMLElement | null =>
    document.querySelector<HTMLElement>(anchorRootSelector(itemId));

type ResolveAnchorInput = {
    readonly itemId: string;
    readonly commentId: string;
    readonly target: CommentTarget;
    readonly root?: HTMLElement;
};

export const resolveAnchor = ({ itemId, commentId, target, root }: ResolveAnchorInput): HTMLElement | null => {
    const scope = root ?? resolveAnchorRoot(itemId);
    if (is.null(scope)) {
        return null;
    }
    if (target.kind === 'title') {
        return scope.querySelector<HTMLElement>(titleAnchorSelector(itemId));
    }
    if (target.kind === 'skill') {
        return scope.querySelector<HTMLElement>(skillAnchorSelector(target.skillId));
    }
    if (target.kind === 'workflow-step') {
        return scope.querySelector<HTMLElement>(workflowStepAnchorSelector(target.workflowStepId));
    }
    if (target.kind === 'workflow-step-title' || target.kind === 'workflow-step-description') {
        return scope.querySelector<HTMLElement>(workflowStepPartAnchorSelector(target.kind, target.stepIndex));
    }
    return scope.querySelector<HTMLElement>(commentMarkSelector(commentId));
};
